import type { IFlagsmith } from "flagsmith/react";

export const identifyFlagsmithUser = (
  flagsmith: IFlagsmith,
  userId: string,
  properties: { region: string; name: string; email: string; roles: string },
) => {
  flagsmith.identify(userId, properties);
};
